import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { ModalSize } from '..';
export var ModalSubHeader = function (props) {
    var sizeClass = props.size === ModalSize.MEDIUM ? 'medium' : 'large';
    var classNames = namespacedClassnames('modal-sub-header', sizeClass, props.className);
    return (React.createElement("div", { className: classNames }, props.children));
};
//# sourceMappingURL=modal-sub-header.js.map